import { NAVBAR_BRAND_ROUTES, TABLES_REF } from "./index";

export const getActiveRoute = (title, path) => {
  let flag = false;
  NAVBAR_BRAND_ROUTES[title].forEach((route) => {
    //retreive raw page link.
    //EXAMPLE: "/route/:id" converts into "route"
    if (route.includes(":")) {
      route = route.slice(0, route.indexOf(":"));
    }

    if (path.search(route) === 0) {
      flag = true;
    }
  });

  return flag;
};

export const getBrandName = (path) => {
  let keys = Object.keys(NAVBAR_BRAND_ROUTES);
  let brand = "";
  keys.forEach((key) => {
    NAVBAR_BRAND_ROUTES[key].forEach((route) => {
      if (path.search(route) === 0) {
        brand = key;
      }
    });
  });
  return brand;
};

export const getTableList = (refr) => {
  switch (refr) {
    case "master-config-action-history-table":
      return TABLES_REF.MASTER_CONFIG_ACTION_HISTORY_TABLE;
    case "product-catalog":
      return TABLES_REF.PRODUCT_TABLE;
    case "add-multiple-vm-for-planogram":
      return TABLES_REF.ADD_MULTIPLE_VM_FOR_PLANOGRAM;
    case "add-shipping-product-catalog":
      return TABLES_REF.ADD_SHIPPING_STEP3_TABLE;
    case "users-list":
      return TABLES_REF.USERS_TABLE;
    case "master-data-setup-list":
      return TABLES_REF.MASTER_DATA_SETUP;
    case "generated-reports":
      return TABLES_REF.GENERATED_REPORTS;
    case "role-list":
      return TABLES_REF.ROLES_TABLE;
    case "brand-list":
      return TABLES_REF.BRANDS_TABLE;
    case "tally-order-modal":
      return TABLES_REF.TALLY_ORDER_MODAL;
    case "warehouse-list":
      return TABLES_REF.WAREHOUSE_TABLE;
    case "incident-list":
      return TABLES_REF.INCIDENT_LIST;
    case "technician-logs":
      return TABLES_REF.TECHNICIAN_LOGS;
    case "motor-action-logs":
      return TABLES_REF.MOTOR_ACTION_LOGS;
    case "incident-type-list":
      return TABLES_REF.INCIDENT_TYPE_LIST;
    case "add-incident-type-list":
      return TABLES_REF.ADD_INCIDENT_TYPE_LIST;
    case "job-list":
      return TABLES_REF.JOB_LIST;
    case "warehouse-orders-list":
      return TABLES_REF.WAREHOUSE_ORDERS_TABLE;
    case "product-unit-list":
      return TABLES_REF.UNITS_TABLE;
    case "product-packaging-list":
      return TABLES_REF.PACKAGING_TABLE;
    case "product-category-list":
      return TABLES_REF.CATEGORY_TABLE;
    case "franchise-list":
      return TABLES_REF.FRANCHISE_TABLE;
    case "inventory-list":
      return TABLES_REF.INVENTORY_TABLE;
    case "shipping-list":
      return TABLES_REF.SHIPPING_TABLE;
    case "zone-list":
      return TABLES_REF.ZONE_TABLE;
    case "delivery-partner-list":
      return TABLES_REF.DELIVERY_PARTNER_TABLE;
    case "store-list":
      return TABLES_REF.STORE_TABLE;
    case "vendingMachine-list":
      return TABLES_REF.VENDING_MACHINE_TABLE;
    case "requested-list":
      return TABLES_REF.PRODUCT_REQUESTED_TABLE;
    case "add-shipping-step2":
      return TABLES_REF.ADD_SHIPPING_STEP2_TABLE;
    case "add-shipping-step4":
      return TABLES_REF.ADD_SHIPPING_STEP4_TABLE;
    case "add-shipping-step5":
      return TABLES_REF.ADD_SHIPPING_STEP5_TABLE;
    case "add-warehouse-inventory-step1":
      return TABLES_REF.ADD_WAREHOUSE_INVENTORY_STEP1_TABLE;
    case "add-warehouse-inventory-step2":
      return TABLES_REF.ADD_WAREHOUSE_INVENTORY_STEP2_TABLE;
    case "add-warehouse-inventory-step3":
      return TABLES_REF.ADD_WAREHOUSE_INVENTORY_STEP3_TABLE;
    case "shipping-view-product-list":
      return TABLES_REF.SHIPPING_VIEW_PRODUCT_TABLE;
    case "delivery-person-list":
      return TABLES_REF.DELIVERY_PERSON_TABLE;
    case "refill-partner-list":
      return TABLES_REF.REFILL_PARTNER_TABLE;
    case "technician-partner-list":
      return TABLES_REF.TECHNICIAN_PARTNER_LIST;
    case "technician-transaction-list":
      return TABLES_REF.TECHNICIAN_TRANSACTION_LIST;
    case "refill-management-list":
      return TABLES_REF.REFILL_MANAGEMENT_TABLE;
    case "configured-vending-machine-list":
      return TABLES_REF.CONFIGURED_VENDING_MACHINE_TABLE;
    case "configured-technician-vending-machine-list":
      return TABLES_REF.CONFIGURED_TECHNICIAN_VENDING_MACHINE_TABLE;
    case "available-vending-machine-list":
      return TABLES_REF.AVAILABLE_VENDING_MACHINE_TABLE;
    case "store-inventory":
      return TABLES_REF.STORE_INVENTORY_TABLE;
    case "dashboard-inventory":
      return TABLES_REF.DASHBOARD_INVENTORY_TABLE;
    case "refill-view-table":
      return TABLES_REF.REFILL_VIEW_TABLE;
    case "topup-view-table":
      return TABLES_REF.TOPUP_VIEW_TABLE;
    case "vm-view-table":
      return TABLES_REF.VM_VIEW_TABLE;
    case "refill-sku-table":
      return TABLES_REF.REFILL_SKU_TABLE;
    case "topup-sku-table":
      return TABLES_REF.TOPUP_SKU_TABLE;
    case "tally-sku-table":
      return TABLES_REF.TALLY_SKU_TABLE;
    case "tally-view-table":
      return TABLES_REF.TALLY_VIEW_TABLE;
    case "vm-sku-table":
      return TABLES_REF.VM_SKU_TABLE;
    case "dashboard-franchise":
      return TABLES_REF.DASHBOARD_FRANCHISE_TABLE;
    case "dashboard-retailer":
      return TABLES_REF.DASHBOARD_RETAILER_TABLE;
    case "dashboard-vm":
      return TABLES_REF.DASHBOARD_VM_TABLE;
    case "dashboard-brand":
      return TABLES_REF.DASHBOARD_BRAND_TABLE;
    case "dashboard-product":
      return TABLES_REF.DASHBOARD_PRODUCT_TABLE;
    case "purchase-order-list":
      return TABLES_REF.PURCHASE_ORDER_TABLE;
    case "direct-sale-order-list":
      return TABLES_REF.DIRECT_SALE_ORDER_TABLE;
    case "order-cart":
      return TABLES_REF.ORDER_CART_TABLE;
    case "vm-feedback":
      return TABLES_REF.VM_FEEDBACK_TABLE;
    case "product-feedback":
      return TABLES_REF.PRODUCT_FEEDBACK_TABLE;
    case "refund-table":
      return TABLES_REF.REFUND_TABLE;
    case "sales-analytics-singular-table":
      return TABLES_REF.SALES_ANALYTICS_SINGULAR_TABLE;
    case "sales-analytics-grouped-table":
      return TABLES_REF.SALES_ANALYTICS_GROUPED_TABLE;
    case "coupon-list":
      return TABLES_REF.COUPON_TABLE;
    case "discount-list":
      return TABLES_REF.DISCOUNT_TABLE;
    case "discount-products-flat":
      return TABLES_REF.DISCOUNT_PRODUCTS_FLAT;
    case "campaign-sub-offer-table":
      return TABLES_REF.CAMPAIGN_SUB_OFFER_TABLE;
    case "discount-products-percentage":
      return TABLES_REF.DISCOUNT_PRODUCTS_PERCENTAGE;
    case "discount-products-buyXforY":
      return TABLES_REF.DISCOUNT_PRODUCTS_BUYXFORY;
    case "discount-products-buyXgetY":
      return TABLES_REF.DISCOUNT_PRODUCTS_BUYXGETY;
    case "sales-template-list":
      return TABLES_REF.SALES_TEMPLATE_LIST;

    case "purchase-order-list-table":
      return TABLES_REF.PURCHASE_ORDER_TABLE_LIST;
    case "purchase-return-view-table":
      return TABLES_REF.PURCHASE_RETURN_VIEW_TABLE;
    case "purchase-return-list-table":
      return TABLES_REF.PURCHASE_RETURN_TABLE_LIST;
    case "add-purchase-order-warehouse-selection":
      return TABLES_REF.ADD_PURCHASE_ORDER_WAREHOUSE_SELECTION;
    case "modify-purchase-order-product-selection":
      return TABLES_REF.MODIFY_PURCHASE_ORDER_PRODUCT_SELECTION;
    case "modify-purchase-order-product-supplier-selection":
      return TABLES_REF.MODIFY_PURCHASE_ORDER_PRODUCT_SUPPLIER_SELECTION;
    case "modify-purchase-order-product-supplier-review":
      return TABLES_REF.MODIFY_PURCHASE_ORDER_PRODUCT_SUPPLIER_REVIEW;
    case "add-supplier-product-selection":
      return TABLES_REF.ADD_SUPPLIER_PRODUCT_SELECTION;
    case "supplier-list-table":
      return TABLES_REF.SUPPLIER_LIST_TABLE;
    case "add-supplier-terms-of-service":
      return TABLES_REF.ADD_SUPPLIER_TERMS_OF_SERVICE;
    case "supplier-view-products-table":
      return TABLES_REF.SUPPLIER_VIEW_PRODUCTS_TABLE;
    case "purchase-order-view-table":
      return TABLES_REF.PURCHASE_ORDER_VIEW_TABLE;
    case "purchase-order-manage-view-table":
      return TABLES_REF.PURCHASE_ORDER_MANAGE_VIEW_TABLE;
    case "purchase-order-manage-view-table-with-inputs":
      return TABLES_REF.PURCHASE_ORDER_MANAGE_VIEW_TABLE_WITH_INPUTS;
    case "store-manager-list-table":
      return TABLES_REF.STORE_MANAGER_LIST_TABLE;
    case "store-manager-store-selection":
      return TABLES_REF.STORE_MANAGER_STORE_SELECTION;
    case "vm-template-list-table":
      return TABLES_REF.VM_TEMPLATE_LIST_TABLE;
    case "vm-template-view-pms":
      return TABLES_REF.VM_TEMPLATE_VIEW_PMS;
    case "refill-partner-view-vms":
      return TABLES_REF.REFILL_PARTNER_TEMPLATE_VIEW_VMS;
    case "bulk-refill-list-table":
      return TABLES_REF.BULK_REFILL_LIST_TABLE;
    case "bulk-refill-overview-table":
      return TABLES_REF.BULK_REFILL_OVERVIEW_TABLE;
    case "vm-settings-list-table":
      return TABLES_REF.VM_SETTINGS_LIST_TABLE;
    case "refill-plan-return-order":
      return TABLES_REF.REFILL_PLAN_RETURN_ORDER;
    case "transaction-email-report-columns":
      return TABLES_REF.TRANSACTION_EMAIL_REPORT_COLUMNS;
    case "bulk-refill-popup-vm-list":
      return TABLES_REF.BULK_REFILL_POPUP_VM_LIST;
    case "order-refund":
      return TABLES_REF.ORDER_REFUND_TABLE;
    case "order-receipt-table":
      return TABLES_REF.ORDER_RECEIPT_TABLE;
    case "vm-snapshot-expiry-dates-modal":
      return TABLES_REF.VM_SNAPSHOT_EXPIRY_DATES_MODAL;
    case "planogram-templates-list":
      return TABLES_REF.PLANOGRAM_TEMPLATE_LIST;
    case "refill-view-list":
      return TABLES_REF.REFILL_LIST_VIEW_TABLE;
    case "return-view-list":
      return TABLES_REF.RETURN_LIST_VIEW_TABLE;
    case "return-order-table":
      return TABLES_REF.RETURN_ORDER_TABLE;
    case "low_qty_table":
      return TABLES_REF.LOW_QTY_DATA;
    case "vending-machine-deleted-table":
      return TABLES_REF.DELETED_VENDING_MACHINES_TABLE;
    case "hardware-board-table":
      return TABLES_REF.HARDWARE_BOARD_TABLE;
    case "store-return-order-table":
      return TABLES_REF.STORE_RETURN_ORDERS_TABLE;
    case "store-vm-return-order-table":
      return TABLES_REF.STORE_VM_RETURN_ORDERS_TABLE;

    case "store-return-order-warehouse-list":
      return TABLES_REF.STORE_RETURN_ORDERS_WAREHOUSE_TABLE;
    case "vm-return-order-warehouse-list":
      return TABLES_REF.VM_RETURN_ORDERS_WAREHOUSE_TABLE;
    case "store-return-order-overview-warehouse-list":
      return TABLES_REF.STORE_RETURN_ORDERS_OVERVIEW_WAREHOUSE_TABLE;
    case "store-store-return-order-overview-table":
      return TABLES_REF.STORE_STORE_RETURN_ORDERS_OVERVIEW_TABLE;
    case "vm-return-order-overview-table":
      return TABLES_REF.VM_RETURN_ORDERS_OVERVIEW_TABLE;
    case "receive-return-order-table":
      return TABLES_REF.RECEIVE_RETURN_ORDER_TABLE;
    case "create-store-return-order":
      return TABLES_REF.CREATE_STORE_RETURN_ORDER;
    case "finance-report-list":
      return TABLES_REF.CREATE_FINANCE_REPORT_LIST;
    case "retailers-list":
      return TABLES_REF.CREATE_RETAILERS_LIST;
    case "reports-list":
      return TABLES_REF.CREATE_REPORT_LIST;
    case "linked_warehouse_managers_table":
      return TABLES_REF.LINKED_WAREHOUSE_MANAGERS_TABLE;
    case "linked_store_managers_table":
      return TABLES_REF.LINKED_STORE_MANAGERS_TABLE;
    case "user_overview_table":
      return TABLES_REF.USER_OVERVIEW_TABLE;
    case "create_purchase_order_table":
      return TABLES_REF.CREATE_PURCHASE_ORDER_TABLE;
    case "create_purchase_return_table":
      return TABLES_REF.CREATE_PURCHASE_RETURN_TABLE;
    case "create_shipping_order_table":
      return TABLES_REF.CREATE_SHIPPING_ORDER_TABLE;
    case "create_tally_order_inventory_table":
      return TABLES_REF.CREATE_TALLY_ORDER_INVENTORY_TABLE;
    case "warehouse_stock_table":
      return TABLES_REF.WAREHOUSE_STOCK_TABLE;
    case "supplier-return-overview-table":
      return TABLES_REF.SUPPLIER_RETURN_OVERVIEW_TABLE;
    case "material-overview-table":
      return TABLES_REF.MATERIAL_TRANSFER_OVERVIEW_TABLE;
    case "material-overview-qr-table":
      return TABLES_REF.MATERIAL_TRANSFER_OVERVIEW_QR_TABLE;
    case "transfer-order-overview-table":
      return TABLES_REF.TRANSFER_ORDER_OVERVIEW_TABLE;
    case "kit-transfer-overview-table":
      return TABLES_REF.KIT_TRANSFER_OVERVIEW_TABLE;
    case "tally-increase-table":
      return TABLES_REF.TAllY_INCREASE_TABLE;
    case "tally-decrease-table":
      return TABLES_REF.TAllY_DECREASE_TABLE;
    case "tally-failed-table":
      return TABLES_REF.TAllY_FAILED_TABLE;
    case "tally-no-change-table":
      return TABLES_REF.TAllY_NO_CHANGE_TABLE;
    case "discarded-bin-table-list":
      return TABLES_REF.DISCARDED_BIN;
    case "tally-inventory-table-list":
      return TABLES_REF.TALLY_INVENTORY;
    case "feedback-table":
      return TABLES_REF.FEEDBACK_TABLE;
    case "customer-feedback-list":
      return TABLES_REF.CUSTOMER_FEEDBACK_LIST;
    case "advertisement-list":
      return TABLES_REF.ADVERTISEMENT_LIST;
    case "vm-failure":
      return TABLES_REF.VM_FAILURE;
    case "vm-revenue":
      return TABLES_REF.VM_REVENUE;
    case "vm-offline":
      return TABLES_REF.VM_OFFLINE;
    case "vm-maintenance":
      return TABLES_REF.VM_MAINTENANCE_LIST;
    case "top-selling-product":
      return TABLES_REF.TOP_SELLING_PRODUCTS;
    case "link_refill_partner_table":
      return TABLES_REF.LINK_REFILL_PARTNER_TABLE;
    case "edit_link_refill_partner_table":
      return TABLES_REF.EDIT_LINK_REFILL_PARTNER_TABLE;
    case "link_warehouse_manager_table":
      return TABLES_REF.LINK_WAREHOUSE_MANAGER_TABLE;
    case "link_warehouse_wm_table":
      return TABLES_REF.LINK_WAREHOUSE_WM_TABLE;

    case "edit_link_warehouse_manager_table":
      return TABLES_REF.EDIT_LINK_WAREHOUSE_MANAGER_TABLE;
    case "edit_link_warehouse_for_wm_table":
      return TABLES_REF.EDIT_LINK_WAREHOUSE_FOR_WM_TABLE;
    case "customer-platform-list":
      return TABLES_REF.CUSTOMER_PLATFORM_LIST;
    case "platform-linked-vm-list":
      return TABLES_REF.PLATFORM_LINKED_VM_LIST;
    case "vm-restricted-product-list":
      return TABLES_REF.VM_RESTRICTED_PRODUCT_LIST;
      case "link_vm_table":
        return TABLES_REF.LINK_VENDING_MACHINE_TABLE;
      case "technician_link_vm_table":
        return TABLES_REF.TECHNICIAN_LINK_VENDING_MACHINE_TABLE;
    case "link_warehouse_table":
      return TABLES_REF.LINK_WAREHOUSE_TABLE;
    case "edit_link_warehouse_table":
      return TABLES_REF.EDIT_LINK_WAREHOUSE_TABLE;
    case "link_vehicle_table":
      return TABLES_REF.LINK_VEHICLE_TABLE;
    case "edit_link_vehicle_table":
      return TABLES_REF.EDIT_LINK_VEHICLE_TABLE;
    case "negative-item-list":
      return TABLES_REF.NEGATIVE_ITEM_LIST;
    case "link_item_table":
      return TABLES_REF.LINK_ITEM_TABLE;
    case "request-product-view":
      return TABLES_REF.REQUEST_PRODUCT_VIEW;
    case "kit-vm-table":
      return TABLES_REF.KIT_VM_TABLE;
    case "kit-preview-machine-table":
      return TABLES_REF.KIT_PREVIEW_MACHINE_TABLE;
    case "kit-stock_availability-table":
      return TABLES_REF.KIT_STOCK_AVAILABILITY_TABLE;
    case "kit-add-more-item-table":
      return TABLES_REF.KIT_ADD_MORE_ITEM_TABLE;
    case "sale-order-view-table":
      return TABLES_REF.SALE_ORDER_VIEW_TABLE;
    case "cash_in_hand-order-table":
      return TABLES_REF.CASH_IN_HAND_ORDER_TABLE;
    case "direct-sale-table":
      return TABLES_REF.DIRECT_SALE_TABLE;
    case "request-order-overview-table":
      return TABLES_REF.REQUEST_ORDER_OVERVIEW_TABLE;
    case "offer-view-table":
      return TABLES_REF.OFFER_VIEW_TABLE;
    case "sob_offer-view-table":
      return TABLES_REF.SUB_OFFER_VIEW_TABLE;
    case "pg-view-table":
      return TABLES_REF.PG_VIEW_TABLE;
    case "action-history-table":
      return TABLES_REF.ACTION_HISTORY_TABLE;
    case "link_warehouse_technician_table":
      return TABLES_REF.LINK_WAREHOUSE_TECHNICIAN_TABLE;
    case "motor-details":
      return TABLES_REF.MOTOR_DETAILS;
    case "machine-event-log":
      return TABLES_REF.MACHINE_EVENT_LOG;
    case "sync-product-list":
      return TABLES_REF.SYNC_PRODUCT_LIST_TABLE;
    case "sync-brand-catalogues":
      return TABLES_REF.SYNC_BRAND_CATALOGUES_TABLE;
    case "sync-catalogue-products":
      return TABLES_REF.SYNC_CATALOGUE_PRODUCTS_TABLE;
    case "new-product-list":
      return TABLES_REF.NEW_PRODUCT_LIST_TABLE;
    default:
      return [];
  }
};
